// extracted by mini-css-extract-plugin
export default {"navIcon":"_17ICg2yz"};